export default {
    namespaced: true,
    state () {
        return {
            id: 0,
            title: '',
            subtitle: '',
            slug: '',
            sku: '',
            categories: [],
            brands: [],
            tags: [],
            content: '',
            short_description: '',
            meta_description: '',
            meta_keywords: '',
            status: '',
            stocks: [],
            gallery: [],
            attribute_entities: [],
            attribute_entity_notes: {},
            attribute_entity_options: {},
            attribute_values: [],
            variables: [],
            variations: [],
            errors: {},
            lock: null,
            type: '',
            selected_variable_id: null,
            is_wishlisted: false,
            is_waiting_listed: false,
            initialized: false
        }
    },
    getters: {
        isLoaded(state) {
            return !!state.id;
        },
        selectedVariable(state) {
            return state.variables.filter(variable => {
                return variable.id === state.selected_variable_id;
            })[0];
        }
    },
    mutations: {
        init (state, data) {
            for (const [key, value] of Object.entries(data)) {
                state[key] = value;
            }
            state.initialized = true;
        },
        setSelectedVariableId (state, data) {
            state.selected_variable_id = Number(data);
        }
    }
}
